import api from '../api/client';
export const groupAccountOptions = (accounts) => {
    return Object.entries(
        accounts.reduce((acc, option) => {
            if (!acc[option.category]) acc[option.category] = [];
            acc[option.category].push(option);
            return acc;
        }, {})
    ).map(([label, options]) => ({
        label,
        options: options.map((item) => ({
            value: item.gl_code,
            label: `${item.gl_code} - ${item.account_name}`
        }))
    }));
};

export const currencyFormat = (num) =>
    new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
    }).format(num);
